import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";

const OesCtaBanner: React.FC = () => (
  <section className="wdev-cta" aria-labelledby="oes-cta-title">
    <div className="container">
      <AnimatedSection>
        <motion.div className="wdev-cta__inner" whileHover={{ scale: 1.005 }} transition={{ duration: 0.3 }}>
          <div className="wdev-cta__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M9 12l2 2 4-4" stroke="#2563eb" strokeWidth="1.5" strokeLinecap="round" />
              <rect x="4" y="4" width="16" height="16" rx="3" stroke="#2563eb" strokeWidth="1.5" />
            </svg>
          </div>
          <div className="wdev-cta__text">
            <h2 id="oes-cta-title" className="wdev-cta__title">
              Ready to Go Digital with Your Exams?
            </h2>
            <p className="wdev-cta__subtitle">
              Get a demo of our Online Exam Software — secure proctoring, auto-grading, and instant results in one platform.
            </p>
          </div>
          <Link to="/contact" className="wdev-cta__btn">
            Get In Touch
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path
                d="M3 8h10M9 4l4 4-4 4"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        </motion.div>
      </AnimatedSection>
    </div>
  </section>
);

export default OesCtaBanner;
